import { render } from "./BasketPage.vue?vue&type=template&id=ede0b3f2&scoped=true"
import script from "./BasketPage.vue?vue&type=script&lang=js"
export * from "./BasketPage.vue?vue&type=script&lang=js"

import "./BasketPage.vue?vue&type=style&index=0&id=ede0b3f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede0b3f2"]])

export default __exports__